import { aggregateRating, offers } from '@iheartjane/menu';
import type { Nullish } from '@iheartjane/types';

import { isNotNull } from '@jane/bloom/utils/guards/isNotNull';
import type { ProductViewModel } from '@jane/bloom/viewModels/productDetail';
import { buildProductMetadataViewModel } from '@jane/bloom/viewModels/productMetadata';

import { jsonLD, jsonLDProperty } from './jsonLD';

/**
 * @see https://developers.google.com/search/docs/appearance/structured-data/product-snippet
 */
export function productStructuredData(
  product?: ProductViewModel,
  currencyCode?: Nullish<'USD' | 'CAD'>
) {
  if (!product) {
    return {};
  }

  const { additional, ...productData } = buildProductMetadataViewModel(product);

  return jsonLD({
    '@type': 'Product',
    ...productData,
    ...aggregateRating({
      aggregate_rating: product.aggregate_rating,
      review_count: product.review_count,
    }),
    ...offers({ currency_code: currencyCode ?? 'USD', ...product }),
    additionalProperty: [
      jsonLDProperty('Lineage', additional.lineage),
      jsonLDProperty('Flavors', additional.flavorsList),
      jsonLDProperty('Effects', additional.effectsList),
    ].filter(isNotNull),
  });
}
